<template>
  <ModalDialog
    ref="dialog"
    title="Open Glass Block"
    icon="fa-box-open"
    :showFooter="true"
    :scrollable="true"
    :submitDisabled="isSubmitDisabled"
    :submitting="submitting"
    submitTitle="Open Block"
    @closed="onClosed"
    @submitted="onSubmitted">

    <Spinner v-if="loadingData" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-show="!loadingData">
      <h2>Glass Block {{glassBlock.stock.code}} - {{glassBlock.stock.name}}</h2>
      <h3>{{glassBlock.sheetQuantity}} sheet quantity of {{glassBlock.height}}x{{glassBlock.width}}</h3>
      <br /><br />
      <div class="row">
        <div class="col-9">
          <p>Confirm to open glass block <strong>{{glassBlock.barcode}}</strong>?</p>
          <p>This will convert the block into {{glassBlock.sheetQuantity}} loose sheets</p>
        </div>
        <div class="col-3">
          <FormSwitch booleanMode v-model="openBlock" />
        </div>
      </div>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'GlassBlockCuttingDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    glassBlockId: Number,
    glassBlock: Object,
    productionStageId: Number,
    productionStationId: Number
  },
  data() {
    return {
      loadingData: false,
      form: {},
      openBlock: false,
      sheetCutQuantity: 0,
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    isSubmitDisabled() {
      return !this.openBlock
    }
  },
  methods: {
    show() {
      this.form = {}

      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      // Send open block request
      this.form = this.clearFormResponse()

      this.submitting = true
      this.$apiService.glassProductionStationService.openGlassBlockCutSheet(this.productionStationId, this.glassBlockId, { quantity: 0 })
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>